import { render, staticRenderFns } from "./Sound.vue?vue&type=template&id=051e2111&scoped=true"
import script from "./Sound.vue?vue&type=script&lang=js"
export * from "./Sound.vue?vue&type=script&lang=js"
import style0 from "./Sound.vue?vue&type=style&index=0&id=051e2111&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051e2111",
  null
  
)

export default component.exports